import { combineReducers } from 'redux';
import types from './types';
import {
  IEligibleResponse,
  IStatusResponse,
  IEligibleItem,
  IReturnAlert
} from 'src/services/returns/typings';

export interface IReturnError {
  hasError: boolean;
  message: string;
  status?: any;
}

const INITIAL_ERROR = {
  hasError: false,
  message: ''
};

const isPending = (
  state: boolean = false,
  { type, payload }: { type: string; payload: boolean }
) => {
  switch (type) {
    case types.SET_RETURN_IS_PENDING:
      return payload;

    default:
      return state;
  }
};

const isDownloadingPdf = (
  state: boolean = false,
  { type, payload }: { type: string; payload: boolean }
) => {
  switch (type) {
    case types.SET_RETURN_IS_DOWNLOADING_PDF:
      return payload;

    default:
      return state;
  }
};

const error = (
  state: IReturnError = INITIAL_ERROR,
  { type, payload }: { type: string; payload: IReturnError }
) => {
  switch (type) {
    case types.SET_RETURN_ERROR:
      return payload;
    default:
      return state;
  }
};

const eligibleData = (
  state: IEligibleResponse = null,
  { type, payload }: { type: string; payload: IEligibleResponse }
) => {
  switch (type) {
    case types.SET_RETURN_ELIGIBLE_DATA:
      return payload;
    default:
      return state;
  }
};

const partsToReturn = (
  state: IEligibleItem = null,
  { type, payload }: { type: string; payload: IEligibleItem }
) => {
  switch (type) {
    case types.SET_RETURN_PARTS_TO:
      return payload;
    default:
      return state;
  }
};

const eligibleCoreData = (
  state: IEligibleResponse = null,
  { type, payload }: { type: string; payload: IEligibleResponse }
) => {
  switch (type) {
    case types.SET_RETURN_ELIGIBLE_CORE_DATA:
      return payload;
    default:
      return state;
  }
};

const statusData = (
  state: IStatusResponse = null,
  { type, payload }: { type: string; payload: IStatusResponse }
) => {
  switch (type) {
    case types.SET_RETURN_STATUS_DATA:
      return payload;
    default:
      return state;
  }
};

const returnAlert = (
  state: IReturnAlert = null,
  { type, payload }: { type: string; payload: IReturnAlert }
) => {
  switch (type) {
    case types.SET_RETURN_ALERT:
      return payload;
    default:
      return state;
  }
};

const returnStatusAlert = (
  state: IReturnAlert = null,
  { type, payload }: { type: string; payload: IReturnAlert }
) => {
  switch (type) {
    case types.SET_RETURN_STATUS_ALERT:
      return payload;
    default:
      return state;
  }
};

const rmaList = (
  state: string[] = null,
  { type, payload }: { type: string; payload: string[] }
) => {
  switch (type) {
    case types.SET_RETURN_RMA_LIST:
      return payload;
    default:
      return state;
  }
};

const isCloseModalIfError = (
  state: boolean = false,
  { type, payload }: { type: string; payload: boolean }
) => {
  switch (type) {
    case types.SET_MODAL_IF_RETURN_ERROR:
      return payload;

    default:
      return state;
  }
};

export default combineReducers({
  isPending,
  error,
  partsToReturn,
  eligibleData,
  eligibleCoreData,
  statusData,
  rmaList,
  returnAlert,
  returnStatusAlert,
  isDownloadingPdf,
  isCloseModalIfError
});
